import { forwardRef } from 'react'
import { tw } from 'twind'

export type BoxOwnProps<E extends React.ElementType = React.ElementType> = {
  as?: E
  className?: string
}

export type BoxProps<E extends React.ElementType> = BoxOwnProps<E> &
  Omit<React.ComponentProps<E>, keyof BoxOwnProps>

const defaultElement = 'div'

export const Box: <E extends React.ElementType = typeof defaultElement>(
  props: BoxProps<E>
) => React.ReactElement | null = forwardRef(
  (
    { as: Element = defaultElement, className, ...props }: BoxOwnProps,
    ref: React.Ref<Element>
  ) => (
    <Element
      className={className ? tw(className) : undefined}
      ref={ref}
      {...props}
    />
  )
)

export default Box
